module.exports = __webpack_public_path__ + "static/media/leslie-rhino.243747b9.png";